import {faCheckCircle, faTimesCircle} from '@fortawesome/pro-regular-svg-icons';
import {faEyeSlash} from '@fortawesome/pro-solid-svg-icons';

export const fakesReportIcons = {
    approved: faCheckCircle,
    rejected: faTimesCircle,
    hidden: faEyeSlash,
};
